import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StatusBadge, StatusType } from './StatusBadge.js';

export interface PageHeaderProps {
  readonly title: string;
  readonly description?: string;
  readonly statusType?: StatusType;
  readonly statusLabel?: string;
  readonly actions?: React.ReactNode;
  readonly backTo?: string;
  readonly className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  statusType,
  statusLabel,
  actions,
  backTo,
  className,
}) => {
  const navigate = useNavigate();

  return (
    <header
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        marginBottom: '16px',
      }}
    >
      {backTo && (
        <button
          type="button"
          onClick={() => navigate(backTo)}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            color: 'var(--color-accent)',
            fontSize: '0.85rem',
            fontWeight: 600,
            padding: '4px 0',
            alignSelf: 'flex-start',
            cursor: 'pointer',
          }}
        >
          <span>‹</span>
          <span>Back</span>
        </button>
      )}

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          gap: '12px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          <h1
            style={{
              fontSize: '1.45rem',
              fontWeight: 800,
              letterSpacing: '-0.02em',
              color: 'var(--color-text-primary)',
              margin: 0,
            }}
          >
            {title}
          </h1>
          {statusType && statusType !== 'protected' && (
            <StatusBadge type={statusType} label={statusLabel} />
          )}
        </div>
        {actions && (
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>{actions}</div>
        )}
      </div>

      {description && (
        <p
          style={{
            fontSize: '0.875rem',
            color: 'var(--color-text-secondary)',
            margin: 0,
            lineHeight: 1.45,
            maxWidth: '680px',
          }}
        >
          {description}
        </p>
      )}
    </header>
  );
};
